// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import { Injectable } from '@angular/core';
import {
  GetAppConfigRequest,
  GetAppConfigResponse,
  SetShowAdvancedFeaturesRequest,
  SetShowBackupsFeaturesRequest,
  SetShowDomainsFeaturesRequest,
  SetShowImportFeaturesRequest,
  SetShowIncludedTemplatesRequest,
  SetShowStagingFeaturesRequest,
} from './objects/';
import {
  GetAppConfigRequestInterface,
  GetAppConfigResponseInterface,
  SetShowAdvancedFeaturesRequestInterface,
  SetShowBackupsFeaturesRequestInterface,
  SetShowDomainsFeaturesRequestInterface,
  SetShowImportFeaturesRequestInterface,
  SetShowIncludedTemplatesRequestInterface,
  SetShowStagingFeaturesRequestInterface,
} from './interfaces/';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { HostService } from '../_generated/host.service';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdminCenterApiService {
  constructor(private http: HttpClient, private hostService: HostService) {}

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }

  getAppConfig(r: GetAppConfigRequest | GetAppConfigRequestInterface): Observable<GetAppConfigResponse> {
    const request = (<GetAppConfigRequest>r).toApiJson ? <GetAppConfigRequest>r : new GetAppConfigRequest(r);
    return this.http
      .post<GetAppConfigResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/GetAppConfig',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => GetAppConfigResponse.fromProto(resp)),
        share(),
      );
  }
  setShowAdvancedFeatures(
    r: SetShowAdvancedFeaturesRequest | SetShowAdvancedFeaturesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowAdvancedFeaturesRequest>r).toApiJson
      ? <SetShowAdvancedFeaturesRequest>r
      : new SetShowAdvancedFeaturesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowAdvancedFeatures',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }
  setShowIncludedTemplates(
    r: SetShowIncludedTemplatesRequest | SetShowIncludedTemplatesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowIncludedTemplatesRequest>r).toApiJson
      ? <SetShowIncludedTemplatesRequest>r
      : new SetShowIncludedTemplatesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowIncludedTemplates',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }
  setShowBackupsFeatures(
    r: SetShowBackupsFeaturesRequest | SetShowBackupsFeaturesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowBackupsFeaturesRequest>r).toApiJson
      ? <SetShowBackupsFeaturesRequest>r
      : new SetShowBackupsFeaturesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowBackupsFeatures',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }

  setShowDomainsFeatures(
    r: SetShowDomainsFeaturesRequest | SetShowDomainsFeaturesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowDomainsFeaturesRequest>r).toApiJson
      ? <SetShowDomainsFeaturesRequest>r
      : new SetShowDomainsFeaturesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowDomainsFeatures',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }

  setShowImportFeatures(
    r: SetShowImportFeaturesRequest | SetShowImportFeaturesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowImportFeaturesRequest>r).toApiJson
      ? <SetShowImportFeaturesRequest>r
      : new SetShowImportFeaturesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowImportFeatures',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }

  setShowStagingFeatures(
    r: SetShowStagingFeaturesRequest | SetShowStagingFeaturesRequestInterface,
  ): Observable<HttpResponse<null>> {
    const request = (<SetShowStagingFeaturesRequest>r).toApiJson
      ? <SetShowStagingFeaturesRequest>r
      : new SetShowStagingFeaturesRequest(r);
    return this.http.post<null>(
      this.hostService.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/SetShowStagingFeatures',
      request.toApiJson(),
      { ...this.apiOptions(), observe: 'response' },
    );
  }
}
